
import TabsPage from "../TabsPage";

import ToggleButtons from "components/ToggleButtons";
import Button from "components/Button";
import ButtonIconSelect from "components/ButtonIconSelect";

import InvoiceListPreliminary from "./List/Preliminary";
import InvoiceListForPayment from "./List/ForPayment";
import InvoiceBalance from "./Balance";

export default class Invoice extends TabsPage {
    constructor(props) {
        super(props);

        this.tabs = ["preliminary", "forPayment", "balance"];

        const { subTab } = this._helper.getUrlOptions();
        const savedSubTab = globalThis.savedProps.clientInvoicesTab;
        const subTabValue = subTab || savedSubTab;

        if (subTab)
            globalThis.savedProps.clientInvoicesTab = subTab;
        else if (savedSubTab)
            this.needSetPageProps = true;

        const index = this.tabs.indexOf(subTabValue);
        const mode = (index > -1) ? index : 0;

        this.state = {
            ...this.state,
            mode,
        };

        this.useTooltip = true;
    }

    componentDidMount() {
        if (this.needSetPageProps) {
            const subTab = globalThis.savedProps.clientInvoicesTab;
            this.props.setPageTab(null, { subTab });
        }
    }

    openInvoiceEditor(info) {
        this._helper.openRightPopup("addEditInvoicePopup", { ...info }, this.addUpdateInvoice.bind(this));
    }

    printInvoice(nameReport, info) {
        const { id, clientId, domainId, discount } = info;

        if (discount === 0) {
            nameReport += "_form2";
            //nameReport += "_no_discount";
        }

        this.printShow(nameReport, {
            clientId: clientId.toString(),
            invoiceId: id.toString(),
            clinicId: domainId.toString(),
        });
    }

    async addUpdateInvoice(data) {
        const info = this.props.getAddEditProps(data);
        const { id, clientId, workItemId, parentInvoiceId } = info;
        this._helper.showLoading();

        if (!id)
            info.creationDate = info.createdTime;

        await this._request.invoices.addUpdate(info);

        if (parentInvoiceId) {
            const respDetails = await this._request.invoices.getDetails(parentInvoiceId);
            if (respDetails?.data?.treatmentTask && workItemId) {
                const treatmentTaskId = respDetails.data.treatmentTask.id;
                if (treatmentTaskId) {
                    await this._request.visits.update(workItemId, { treatmentTaskId });
                    const duration = respDetails.data.treatmentTask.duration;
                    const visitTreat = await this._request.visits.getForTreatmentTask(clientId, treatmentTaskId);
                    const countVisit = (visitTreat?.data?.length || 0);
                    if (countVisit >= duration) {
                        await this._request.treatmentTasks.update(treatmentTaskId, { workStatus: 7 });
                    }
                }
            }
        }

        this._helper.hideLoading();

        if (!info.id && info.parentInvoiceId)
            this._helper.showNotify("invoice.createNew", "invoice.createNewTransferred");

        const { addUpdateRepeatedVisit } = this.props;
        const { repeatedVisits } = this.props.info;

        if (info?.securedInvoiceItems?.some(it => it?.items?.some(item => item.name.includes("игиен"))) &&
            !repeatedVisits.some(it => it.reasonId === 1 && new Date(it.targetDate) > new Date())) {

            const overdueVisit = repeatedVisits.find(it => it.reasonId === 1 && new Date(it.targetDate) < new Date());

            if (overdueVisit)
                info.overdueVisitId = overdueVisit.id;

            this.props.openDialog("confirmGigien", info, addUpdateRepeatedVisit);
        } else {
            this.props.refresh();
            this.refresh();
        }
    }

    removeInvoice(info) {
        this.props.openDialog("cancelInvoice", info, this.removeInvoiceConfirm.bind(this));
        /*this._helper.confirm({
            title: "invoice.cancel",
            message: this.tr("invoice.cancelMessage")
        }, this.removeInvoiceConfirm.bind(this, info));*/
    }

    async removeInvoiceConfirm(info) {
        const { id, workItemId, cancelComment } = info;

        this._helper.showLoading();
        await this._request.invoices.delete(id);
        await this._request.invoices.update(id, { cancelComment });
        if (workItemId) {
            await this._request.visits.update(workItemId, {
                treatmentTaskId: null,
            });
            //await this._request.egisz.updateStatus(workItemId, "OPTIMIZING");
        }
        this._helper.hideLoading();

        this.props.refresh();
        this.refresh();

    }

    refresh() {
        this.currentTab?.refresh();
    }

    async addPayHistory(data, cb) {
        const info = this.props.getAddEditProps(data, true);
        info.datetime = info.createdTime;
        info.domainId = this.props.clinicId;

        const sum = info.paidSum + info.sum;
        const createdCheck = (new Date(info.createdAt) > new Date("2024-07-01"));

        delete info.totalSum;
        delete info.paidSum;
        delete info.bonusMisty;
        delete info.createdAt;

        this._helper.showLoading();

        const { checkBonusMisty, externalOrderId } = data.bonusMisty;
        const { mistyClient } = this.props.info;
        const mistyAccept = (createdCheck && info.direction === "DIRECTION_SUBSTRACT" &&
            mistyClient && externalOrderId);

        await this._request.accountHistory.addUpdate(info);
        if (mistyAccept && data.totalSum === sum)
            await this._request.bonusMisty.chargeUp(externalOrderId);
        else if (mistyAccept && checkBonusMisty)
            await this._request.bonusMisty.writeDown(externalOrderId);

        this._helper.hideLoading();

        if (cb?.apply)
            cb();

        this.props.refresh();
    }

    openPaymentDialog(key, props, e) {
        this._helper.stopEvent(e);
        this._helper.openDialog(key, this.props.info.balance, props, this.addPayHistory.bind(this));
    }

    setSubTab() {
        const subTab = this.tabs[this.state.mode];

        this.props.setPageTab(null, { subTab });
        globalThis.savedProps.clientInvoicesTab = subTab;
    }

    changeTab(tab) {
        const index = this.tabs.indexOf(tab);
        if (index > -1)
            this.onTabChange(index);
    }

    onTabChange(mode) {
        this.setState({ mode }, this.setSubTab.bind(this));
    }

    printBalance() {
        const date = this._helper.date.toDateServerStr();

        this.printShow("Advance", {
            clientId: this.props.info.id + "",
            date
        });
    }

    printTranzaktion() {
        this.printShow("client_transactions", {
            clientId: this.props.info.id + "",
            clinicId: this.props.clinicId
        });
    }

    renderModeRightActions(mode) {
        if (mode === 2) {
            return (
                <div className="flex gap16">
                    <Button
                        type={"secondary"}
                        size={"small"}
                        label={"invoice.topUpBalance"}
                        onClick={this.openPaymentDialog.bind(this, "balancePayment", {})}
                    />
                    <ButtonIconSelect
                        name="dots"
                        translate={true}
                        items={[
                            { name: "invoice.refund", onClick: this.openPaymentDialog.bind(this, "returnPayment", {}) },
                            { name: "invoice.transferToAnother", onClick: this.openPaymentDialog.bind(this, "transferPayment", {}) },
                            { line: true },
                            { name: "invoice.printBalance", onClick: this.printBalance.bind(this) },
                            { name: "Печать транзакций", onClick: this.printTranzaktion.bind(this) },
                        ]}
                    />
                </div>
            );
        } else if ((this.props.clinicId === 287 || this.props.clinicId === 1589) || mode === 1) {
            return (
                <Button
                    type={"secondary"}
                    size={"small"}
                    label={"invoice.newBill"}
                    onClick={this.openInvoiceEditor.bind(this, { status: "CREATED", isPre: mode === 1 ? false : true })}
                />
            );
        }
        /*else if (mode === 1) {
            return (
                <Button
                    type={"secondary"}
                    size={"small"}
                    label={"invoice.newBill"}
                    onClick={this.openInvoiceEditor.bind(this, { status: "CREATED" })}
                />
            );
        }*/

        return <></>;
    }

    renderModeBody(mode) {
        const openInvoiceEditor = this.openInvoiceEditor.bind(this);
        const removeInvoice = this.removeInvoice.bind(this);
        const addPayHistory = this.addPayHistory.bind(this);
        const printInvoice = this.printInvoice.bind(this);
        const changeTab = this.changeTab.bind(this);
        const props = { ...this.props, openInvoiceEditor, removeInvoice, addPayHistory, printInvoice, changeTab };

        if (mode === 2)
            return <InvoiceBalance ref={el => this.currentTab = el} {...props} />;
        if (mode === 1)
            return <InvoiceListForPayment ref={el => this.currentTab = el} {...props} />;

        return <InvoiceListPreliminary ref={el => this.currentTab = el} {...props} />;
    }

    renderContent() {
        const { mode } = this.state;

        return (
            <>
                <div className="actions flex between">
                    <ToggleButtons
                        labels={this.tabs.map(str => `invoice.${str}`)}
                        values={[0, 1, 2]}
                        value={mode}
                        onChange={this.onTabChange.bind(this)}
                    />
                    {this.renderModeRightActions(mode)}
                </div>
                {this.renderModeBody(mode)}
            </>
        );
    }
}
